import React, {memo, useEffect} from 'react';
import {RouteName} from '@/app/constants/routing';
import {AnyRouteResult} from '@/app/interfaces/routing';
import {useRoute} from '@/common/services/router';
import {Weather} from '@/app/components/desktop/weather';
import {MapPage} from '@/app/components/desktop/map';
import {NotFound} from '@/app/components/desktop/notFound';

export const AppRouter = memo(() => {
	const {route} = useRoute<AnyRouteResult>();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [route.name]);

	switch (route.name) {
		case RouteName.mainPage:
			return <Weather />;

		case RouteName.weather:
			return <Weather />;

		case RouteName.map: {
			return <MapPage />;
		}
	}

	return <NotFound />;
});

AppRouter.displayName = 'AppRouter';
